<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-form-model
      :model="formInline"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      @submit="handleSubmit"
      @submit.native.prevent
    >
      <a-row>
        <a-col :span="12"> 基本信息</a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="商品名称">
            <a-input v-model="formInline.name" placeholder="请输入商品名称">
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <a-form-model-item label="销售价">
            <a-input v-model="formInline.price" placeholder="请输入销售价">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="门市价">
            <a-input v-model="priceShop" placeholder="请输入门市价"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col v-if="formInline.packageType != 6" :span="11" :offset="2">
          <a-form-model-item label="门票项目">
            <a-select
              mode="multiple"
              v-model="playabilityIdArr"
              style="width: 100%"
              placeholder="请选择门票项目"
              @change="handleChanges"
            >
              <a-select-option
                :value="item.objId"
                v-for="(item, index) in dropDown"
                :key="index"
              >{{ item.projectName }}
              </a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="显示序号">
            <a-input v-model="formInline.sortNum" placeholder="请输入显示序号">
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          
          <a-form-model-item label="门票类型" class="aaa">
            <div style="display: flex;align-items: center;gap: 8px;">
            <a-select
              :offset="2"
              size="default"
              placeholder=""
              style="width: 200px; margin-left: 40px"
              @change="handleChange"
              v-model="formInline.packageType"
            >
              <a-select-option value="1">次数套餐</a-select-option>
              <a-select-option value="2">年卡套餐</a-select-option>
              <a-select-option value="3">月卡套餐</a-select-option>
              <a-select-option value="4">季度卡套餐</a-select-option>
              <a-select-option value="5">半年卡套餐</a-select-option>
              <a-select-option value="6">门票套餐</a-select-option>
            </a-select>
            <a-tooltip  title='如果选择年月季卡套餐的时候，次数填0'>
                <span style="font-size: 20px; color:#1890ff; cursor: pointer;">!</span>
            </a-tooltip>
          </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="套餐销售日期">
            <a-range-picker
              :placeholder="[formInline.startTime, formInline.endTime]"
              @change="onChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="11" :offset="2">
          <!-- <a-form-model-item label="门票年卡">
            <a-input
              v-model="formInline.gameCurrencyNumber"
              placeholder=""
            >
            </a-input>
          </a-form-model-item> -->
          <!--          <a-form-model-item label="门票次数">-->
          <a-form-model-item :label="dynamic_mp_text">
            <!--            <a-input v-model="formInline.count" placeholder="请输入门票次数">-->
            <a-input v-model="formInline.count" :placeholder="dynamic_mp_placeholder">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11"></a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="销售库存数量">
            <a-input v-model="formInline.stock" placeholder="请输销售库存数量">
            </a-input>
          </a-form-model-item>
        </a-col>

        <a-col :span="11" :offset="2">
          <a-form-model-item label="上架星期">
            <a-select
              mode="multiple"
              style="width: 100%"
              placeholder="请选择星期"
              @change="handleChangeDate"
              v-model="week"
            >
              <a-select-option v-for="(item, index) in dateList" :key="index">
                {{ item.date }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="11">
          <a-form-model-item label="限购" class="aaa">
            <a-select
              :offset="2"
              size="default"
              :placeholder="
                formInline.limited == 0
                  ? '不限购'
                  : formInline.limited == 1
                  ? '限购一份'
                  : ''
              "
              style="width: 200px; margin-left: 40px"
              @change="handleChangesss"
            >
              <a-select-option value="0" aria-label="不限购"
              >不限购
              </a-select-option
              >
              <a-select-option value="1" aria-label="限购一份"
              >限购一份
              </a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8" :offset="2">
          <a-form-model-item label="每天限购次数">
            <div style="display: flex;align-items: center;gap: 8px;">
            <a-input
              v-model="formInline.purchaseLimit"
              placeholder="请输入限购次数"
            >
            
            </a-input>
            <a-tooltip  title='优先级：每天限购次数<限购一份'>
                <span style="font-size: 20px; color:#1890ff; cursor: pointer;">!</span>
            </a-tooltip>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col v-if="formInline.packageType != 6" :span="11" :offset="2">
          <a-form-model-item label="门票有效期">
            <a-input
              v-model="formInline.validDate"
              placeholder="请输入门票有效期天数"
            >
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="赠送币">
            <a-input v-model="formInline.freeCoins" placeholder="请输入赠送币">
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="11">
          <a-form-model-item label="商品详情">
            <quill-editor
              v-model="introduceContent"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="11">
          <a-form-model-item label="封面图">
            <a-upload :customRequest="upload">
              <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
                上传
              </a-button>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <a-table :columns="columns" :data-source="data" v-if="show"></a-table>
    <a-button @click="save">保存</a-button>
    <a-button @click="goBack">返回</a-button>
  </div>
</template>

<script>
import {
  addTokensList,
  picUpload,
  detailTokensList,
  ticketXiala,
} from "@/api/storeApi.js";
import {validate} from "json-schema";
import {message} from "ant-design-vue";
import {number} from "echarts";

const columns = [
  {
    title: "Age",

    dataIndex: "name",
    key: "name",
    slots: {title: "customTitle"},
    scopedSlots: {customRender: "name"},
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    scopedSlots: {customRender: "tags"},
  },
  {
    title: "Action",
    key: "action",
    scopedSlots: {customRender: "action"},
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
];
// import chooseAnItem from "./chooseAnItem.vue";
export default {
  components: {
    // chooseAnItem,
  },
  data() {
    return {
      date: [],
      introduceContent: "",
      dateList: [
        {
          date: "星期一",
          value: 1,
        },
        {
          date: "星期二",
          value: 2,
        },
        {
          date: "星期三",
          value: 3,
        },
        {
          date: "星期四",
          value: 4,
        },
        {
          date: "星期五",
          value: 5,
        },
        {
          date: "星期六",
          value: 6,
        },
        {
          date: "星期天",
          value: 7,
        },
      ],
      priceShop: "",
      labelCol: {span: 6},
      wrapperCol: {span: 17, offset: 1},
      formInline: {
        objId: "",
        name: "",
        price: "",
        sortNum: "",
        ticketsType: "",
        count: "",
        img: "",
        startTime: "",
        endTime: "",
        playabilityId: Array,
        stock: "",
        packageType: "",
        limited: "",
        validDate: "",
        freeCoins: '',
        purchaseLimit:0,
      },
      headImg: "",
      data,
      endTime: "",
      starTime: "",
      columns,
      show: false,
      dropDown: [],
      playabilityIdArr: [],
      freeCoins: "",
      week: [],
      dynamic_mp_text: "门票次数",
      dynamic_mp_placeholder: "请输入门票次数",
      dynamic_mp_flag: true,
    };
  },
  watch: {
    dynamic_mp_flag(newVal) {
      if (newVal) {
        this.dynamic_mp_text = '门票次数';
        this.dynamic_mp_placeholder = '请输入门票次数';
      } else {
        this.dynamic_mp_text = '门票金额';
        this.dynamic_mp_placeholder = '请输入门票金额';
      }
    }
  },
  created() {
    // 初始化时根据条件设置默认值
    this.updateLabelAndPlaceholder();
  },
  mounted() {
    this.getDetailTokensListData();
    this.getTicketXiala();
  },
  methods: {
    updateLabelAndPlaceholder() {
      this.dynamic_mp_flag = !(parseInt(this.formInline.packageType) === 6);
      if (this.dynamic_mp_flag) {
        this.dynamic_mp_text = '门票次数';
        this.dynamic_mp_placeholder = '请输入门票次数';
      } else {
        this.dynamic_mp_text = '门票金额';
        this.dynamic_mp_placeholder = '请输入门票金额';
      }
    },
    handleChangesss(value) {
      console.log(value, "esssssssss----------------");
      this.formInline.limited = +value;
      console.log(this.formInline.limited, "esssssssss----------------");
    },
    editorOption(e) {
      console.log(e, "e----------------");
    },
    handleChangeDate(value) {
      this.date = value;
      console.log(value, "handleChangeDate");
    },
    upload(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error("请确保图片大小在2M以内");
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.formInline.img = res.data;
          file.onSuccess(res, file);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error("请确保图片大小在2M以内");
        });
    },
    handleSubmit() {
    },
    handleChange(value) {
      //
      this.dynamic_mp_flag = true;
      if (value == 6) {
        // 门票套餐
        this.dynamic_mp_flag = false;
      }
      this.formInline.ticketsType = value;
    },
    handleChanges(value) {
      console.log(value, "门票项目");
      this.formInline.playabilityId = value;
    },
    onChange(date, dateString) {
      this.formInline.startTime = dateString[0];
      this.formInline.endTime = dateString[1];
    },

    getTicketXiala() {
      ticketXiala({limit: 10, page: 1}).then((res) => {
        this.dropDown = res.data;
      });
    },
    getDetailTokensListData() {
      let objId = this.$route.query.objId || null;
      if (isNaN(parseInt(objId))) {
        return;
      }
      detailTokensList(objId).then((res) => {
        this.formInline.data = objId;
        this.formInline.name = res.data.name;
        this.formInline.price = res.data.spec[0].price;
        this.priceShop = res.data.priceShop;
        this.formInline.objId = res.data.spec[0].objId;
        this.formInline.playabilityId = res.data.spec[0].playabilityId;
        this.formInline.startTime = res.data.spec[0].startTime;
        this.formInline.endTime = res.data.spec[0].endTime;
        this.formInline.packageType = res.data.spec[0].packageType;
        this.headImg = res.data.headImgs[0];
        this.formInline.sortNum = res.data.sortNum;
        this.formInline.stock = res.data.spec[0].stock;
        this.introduceContent = res.data.introduceContent;
        this.formInline.count = res.data.spec[0].count;
        this.formInline.limited = res.data.limited;
        this.formInline.validDate = res.data.validDate;
        console.log("this.formInline.endTime", this.formInline.endTime);
        this.playabilityIdArr = res.data.spec[0].playabilityId;
        this.formInline.freeCoins = res.data.spec[0].freeCoins;
        this.formInline.purchaseLimit = res.data.purchaseLimit;
        this.week = res.data.weekList.map((item) => {
          return item - 1;
        });
        this.updateLabelAndPlaceholder();
        console.log(this.week, "week====>");
      });
    },
    goBack() {
      this.$router.push("/home/ticketPackage/ticketPackageHome");
    },
    showtable(show) {
      this.show = show;
    },
    save() {
      console.log(this.formInline);
      let objId = this.$route.query.objId;
      let obj = {
        name: this.formInline.name,
        priceShop: this.priceShop,
        sortNum: this.formInline.sortNum,
        priceDiscount: 10,
        pricePostage: 0,
        shopRunType: 1401,
        typeId: 653,
        typeSonId: 655,
        objId: objId,
        pricePostageFull: 1,
        spec: [],
        hasDistribution: false,
        goodsType: "common",
        numSales: this.formInline.stock,
        shopId: sessionStorage.getItem("shopId"),
        headImgs: [this.formInline.img],
        weekList: this.date,
        introduceContent: this.introduceContent,
        limited: this.formInline.limited,
        validDate: this.formInline.validDate,
        freeCoins: this.formInline.freeCoins,
        purchaseLimit: this.formInline.purchaseLimit,
      };
      obj.spec.push(this.formInline);
      console.log("obj", obj);
      // return
      if (obj.headImgs[0] === "") {
        obj.headImgs[0] = this.headImg;
      }
      addTokensList(obj).then((res) => {
        this.$router.push("/home/ticketPackage/ticketPackageHome");
        message.success(res.info);
      });
    },
  },
};
</script>

<style scoped>
.aaa {
  width: 255px;
}

img {
  width: 110px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/marketingManagement/ticketPackage/ticketPackageAddTwo.vue